import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import toast from 'react-hot-toast';
import { FiPlus, FiEdit2, FiTrash2, FiDownload, FiEye } from 'react-icons/fi';
import { QRCodeCanvas } from 'qrcode.react';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import AdminLayout from '../../components/layout/AdminLayout';
import api from '../../utils/api';

const empty = { clientName:'', companyName:'', certificateTitle:'Certificate of Training', courseDescription:'', issueDate:'', expiryDate:'', issuedBy:'Joshua Owiredu', issuedByTitle:'Director of Training, SQS' };

// ─── SIGNATURE IMAGE (embedded) ───────────────────────────────────────────────
const SIGNATURE_IMG = "data:image/jpeg;base64,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";

// ─── Certificate Preview Component ────────────────────────────────────────────
// Replace the ENTIRE existing CertPreview component with this
const CertPreview = ({ cert, serial, qrUrl }) => (
  <div id="cert-render" style={{
    width: 654, minHeight: 480, background: 'white',
    fontFamily: "'Times New Roman', Georgia, serif",
    position: 'relative', boxSizing: 'border-box',
    border: '1px solid #ccc',
  }}>

    {/* ── Background grid pattern ── */}
    <div style={{
      position: 'absolute', inset: 0, zIndex: 0,
      backgroundImage: `
        repeating-linear-gradient(0deg, transparent, transparent 18px, rgba(100,160,210,0.12) 18px, rgba(100,160,210,0.12) 19px),
        repeating-linear-gradient(90deg, transparent, transparent 18px, rgba(100,160,210,0.12) 18px, rgba(100,160,210,0.12) 19px)
      `,
    }} />

    {/* ── Outer thick blue border ── */}
    <div style={{ position: 'absolute', inset: 6, border: '7px solid #5B9EC9', zIndex: 1 }} />
    {/* ── Inner thin blue border ── */}
    <div style={{ position: 'absolute', inset: 16, border: '2.5px solid #5B9EC9', zIndex: 1 }} />
    {/* ── Gold inner line ── */}
    <div style={{ position: 'absolute', inset: 21, border: '1px solid #C9A84C', zIndex: 1 }} />

    {/* ── Corner blue triangles ── */}
    {[{ top: 3, left: 3 }, { top: 3, right: 3 }, { bottom: 3, left: 3 }, { bottom: 3, right: 3 }].map((pos, i) => (
      <div key={i} style={{
        position: 'absolute', width: 44, height: 44, zIndex: 2, ...pos,
        background: '#5B9EC9',
        clipPath: i === 0 ? 'polygon(0 0, 100% 0, 0 100%)' :
                  i === 1 ? 'polygon(0 0, 100% 0, 100% 100%)' :
                  i === 2 ? 'polygon(0 0, 0 100%, 100% 100%)' :
                            'polygon(100% 0, 0 100%, 100% 100%)',
      }} />
    ))}

    {/* ── Blue stripe on all 4 edges ── */}
    <div style={{ position: 'absolute', left: 6, top: 6, bottom: 6, width: 10, background: 'repeating-linear-gradient(180deg, #5B9EC9 0px, #5B9EC9 7px, #8BBDD9 7px, #8BBDD9 14px)', zIndex: 1 }} />
    <div style={{ position: 'absolute', right: 6, top: 6, bottom: 6, width: 10, background: 'repeating-linear-gradient(180deg, #5B9EC9 0px, #5B9EC9 7px, #8BBDD9 7px, #8BBDD9 14px)', zIndex: 1 }} />
    <div style={{ position: 'absolute', top: 6, left: 6, right: 6, height: 10, background: 'repeating-linear-gradient(90deg, #5B9EC9 0px, #5B9EC9 7px, #8BBDD9 7px, #8BBDD9 14px)', zIndex: 1 }} />
    <div style={{ position: 'absolute', bottom: 6, left: 6, right: 6, height: 10, background: 'repeating-linear-gradient(90deg, #5B9EC9 0px, #5B9EC9 7px, #8BBDD9 7px, #8BBDD9 14px)', zIndex: 1 }} />

    {/* ── Main content ── */}
    <div style={{
      position: 'relative', zIndex: 3,
      margin: '28px 52px 20px',
      textAlign: 'center',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
    }}>

      {/* ── TOP ROW: Medal | Logo + Title | QR ── */}
      <div style={{
        display: 'flex', alignItems: 'flex-end',
        justifyContent: 'space-between',
        width: '100%', marginBottom: 4,
        marginTop: 15,
      }}>

        {/* Gold Medal */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 80, position: 'absolute', left: 29, top: 300 }}>
          <div style={{ display: 'flex', gap: 2, marginBottom: 2 }}>
            <div style={{ width: 11, height: 18, background: '#C9A84C', clipPath: 'polygon(0 0, 100% 0, 80% 100%, 20% 100%)' }} />
            <div style={{ width: 11, height: 18, background: '#A8873A', clipPath: 'polygon(0 0, 100% 0, 80% 100%, 20% 100%)' }} />
          </div>
          <div style={{
            width: 64, height: 64, borderRadius: '50%',
            background: 'radial-gradient(circle at 32% 32%, #f7e96a, #C9A84C 55%, #8a6d28 85%)',
            border: '4px solid #C9A84C',
            boxShadow: '0 4px 14px rgba(201,168,76,0.55), inset 0 2px 4px rgba(255,255,255,0.3)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>
            <span style={{ fontSize: 22, color: '#7a5c1e' }}>★</span>
          </div>
        </div>

        {/* Center: Logo + Title */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <div style={{ marginBottom: 5, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <img
              src="/logo.png"
              alt="SQS Logo"
              style={{ width: 52, height: 52, objectFit: 'contain', marginBottom: 3 }}
            />
            <div style={{ fontSize: 8.5, fontFamily: 'Arial, sans-serif', fontWeight: 700, color: '#0B2545', letterSpacing: '0.18em', textTransform: 'uppercase' }}>
              Smart Quality Systems
            </div>
          </div>
          <div style={{
            fontSize: 30, fontWeight: 900, color: '#0B2545',
            fontFamily: 'Arial Black, Arial, sans-serif',
            letterSpacing: '0.05em', textTransform: 'uppercase', lineHeight: 1.1,
          }}>
            {cert.certificateTitle || 'Certificate of Training'}
          </div>
        </div>

        {/* QR Code + Serial */}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, width: 80, position: 'absolute', right: 29, top: 300 }}>
          <div style={{ padding: 3, background: 'white', border: '1px solid #ccc', borderRadius: 4 }}>
            {qrUrl
              ? <QRCodeCanvas value={qrUrl} size={64} fgColor="#0B2545" bgColor="#ffffff" />
              : <div style={{ width: 64, height: 64, background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 8, color: '#aaa' }}>QR</div>
            }
          </div>
          <div style={{ fontSize: 9.5, fontWeight: 700, color: '#0B2545', letterSpacing: '0.1em', fontFamily: 'Arial, sans-serif' }}>
            {serial || 'SQS122001'}
          </div>
        </div>

      </div>

      {/* ── Divider ── */}
      <div style={{ width: '72%', height: 1.5, background: 'linear-gradient(90deg, transparent, #C9A84C, transparent)', marginBottom: 8 }} />

      {/* ── Subtitle ── */}
      <div style={{ fontSize: 13, color: '#444', fontStyle: 'italic', marginBottom: 8, fontFamily: 'Georgia, serif' }}>
        This certificate is proudly presented to
      </div>

      {/* ── Recipient Name + gold underline ── */}
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 10 }}>
        <div style={{
          fontSize: 40, fontWeight: 900, color: '#2c5a92',
          fontFamily: 'Arial Black, Arial, sans-serif',
          lineHeight: 1.1, letterSpacing: '0.01em',
        }}>
          {cert.clientName || 'Recipient Name'}
        </div>
        {/* Faint gold underline centered below name */}
        <div style={{
          width: '90%', height: 2,
          background: 'linear-gradient(90deg, transparent, rgba(201,168,76,0.55), transparent)',
          marginTop: 4, borderRadius: 2,
        }} />
      </div>

      {/* ── Course description ── */}
      <div style={{
        fontSize: 15, color: '#222', lineHeight: 1.65,
        fontWeight: 600, maxWidth: 500, marginBottom: 20,
        fontFamily: 'Georgia, serif', textAlign: 'center',
      }}>
        {cert.courseDescription || 'Have successfully completed a training course in [Course Name] on the [Date].'}
      </div>

      {/* ── Signature block (centered, no medal/QR here) ── */}
      <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
        <div style={{ textAlign: 'center', width: 260 }}>
          {/* Actual signature image */}
          <img
            src={SIGNATURE_IMG}
            alt="Signature"
            style={{ height: 52, width: 'auto', maxWidth: 200, objectFit: 'contain', display: 'block', margin: '0 auto 2px' }}
          />
          <div style={{ borderTop: '2px dotted #555', width: '100%', margin: '0 auto 5px' }} />
          <div style={{ fontWeight: 700, fontSize: 12, color: '#0B2545', textTransform: 'uppercase', letterSpacing: '0.08em', fontFamily: 'Arial, sans-serif' }}>
            {cert.issuedBy || 'JOSHUA OWIREDU'}
          </div>
          <div style={{ fontSize: 11, color: '#555', fontStyle: 'italic', marginTop: 2, fontFamily: 'Georgia, serif' }}>
            ({cert.issuedByTitle || 'Director of Training, SQS'})
          </div>
        </div>
      </div>

      {/* ── Issue / Expiry dates ── */}
      {(cert.issueDate || cert.expiryDate) && (
        <div style={{ marginTop: 10, fontSize: 10, color: '#777', fontStyle: 'italic', fontFamily: 'Georgia, serif' }}>
          {cert.issueDate && `Issued: ${new Date(cert.issueDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}`}
          {cert.issueDate && cert.expiryDate && '   |   '}
          {cert.expiryDate && `Valid Until: ${new Date(cert.expiryDate).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' })}`}
        </div>
      )}

    </div>
  </div>
);
export default function AdminCertificates() {
  const [certs, setCerts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(empty);
  const [qrData, setQrData] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [generating, setGenerating] = useState(false);

  const load = () => api.get('/certificates').then(r=>setCerts(r.data)).catch(()=>{});
  useEffect(()=>{ load(); },[]);

  const openForm = (c=null) => {
    setEditing(c); setShowPreview(false); setQrData(null);
    setForm(c?{ clientName:c.client_name, companyName:c.company_name||'', certificateTitle:c.certificate_title, courseDescription:c.course_description||'', issueDate:c.issue_date?c.issue_date.split('T')[0]:'', expiryDate:c.expiry_date?c.expiry_date.split('T')[0]:'', issuedBy:c.issued_by||'Joshua Owiredu', issuedByTitle:c.issued_by_title||'Director of Training, SQS' }:empty);
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); setSubmitting(true);
    try {
      let saved;
      if (editing) { const r = await api.put(`/certificates/${editing.id}`, form); saved = r.data; toast.success('Updated!'); }
      else { const r = await api.post('/certificates', form); saved = r.data; toast.success('Certificate created!'); }
      try { const qr = await api.get(`/certificates/${saved.id}/qrcode`); setQrData(qr.data); } catch{}
      setEditing(saved); setShowPreview(true); setShowForm(false); load();
    } catch { toast.error('Failed to save'); }
    setSubmitting(false);
  };

  const loadPreview = async (c) => {
    try { const r = await api.get(`/certificates/${c.id}/qrcode`); setQrData(r.data); } catch{}
    setEditing(c); setForm({ clientName:c.client_name, companyName:c.company_name||'', certificateTitle:c.certificate_title, courseDescription:c.course_description||'', issueDate:c.issue_date?c.issue_date.split('T')[0]:'', expiryDate:c.expiry_date?c.expiry_date.split('T')[0]:'', issuedBy:c.issued_by||'Joshua Owiredu', issuedByTitle:c.issued_by_title||'Director of Training, SQS' });
    setShowPreview(true); setShowForm(false);
  };

  const downloadPDF = async () => {
  const el = document.getElementById('cert-render');
  if (!el) return;
  setGenerating(true);
  try {
    const canvas = await html2canvas(el, {
      scale: 3,
      useCORS: true,
      allowTaint: true,
      backgroundColor: '#ffffff',
      logging: false,
      imageTimeout: 0,
      onclone: (clonedDoc) => {
        const clonedEl = clonedDoc.getElementById('cert-render');
        if (clonedEl) {
          // Lock exact cert dimensions
          clonedEl.style.width = '654px';
          clonedEl.style.minHeight = '480px';
          clonedEl.style.height = 'auto';
          clonedEl.style.position = 'relative';
          clonedEl.style.transform = 'none';
          clonedEl.style.margin = '0';
          clonedEl.style.padding = '0';
          clonedEl.style.overflow = 'visible';
          clonedEl.style.boxSizing = 'border-box';

          // Force logo image to load
          const imgs = clonedEl.querySelectorAll('img');
          imgs.forEach(img => {
            img.style.display = 'block';
            img.crossOrigin = 'anonymous';
          });

          // Ensure absolutely positioned medal and QR are captured
          // They are at top:300 which is within the cert height
          const allDivs = clonedEl.querySelectorAll('div');
          allDivs.forEach(div => {
            if (div.style.position === 'absolute') {
              div.style.visibility = 'visible';
              div.style.opacity = '1';
            }
          });
        }
      }
    });

    // Calculate PDF dimensions matching cert exactly
    // cert width = 654px, captured at scale 3 = 1962px canvas width
    // convert px to mm: 1px = 0.264583mm
    const certWidthPx = 654;
    const certHeightPx = canvas.height / 3; // divide by scale
    const pxToMm = 0.264583;
    const pdfW = certWidthPx * pxToMm;   // = 173.07mm
    const pdfH = certHeightPx * pxToMm;

    const pdf = new jsPDF({
      orientation: pdfW > pdfH ? 'landscape' : 'portrait',
      unit: 'mm',
      format: [pdfW, pdfH],
    });

    // Fill entire PDF page with the canvas — no gaps, no shifts
    const imgData = canvas.toDataURL('image/png', 1.0);
    pdf.addImage(imgData, 'PNG', 0, 0, pdfW, pdfH, undefined, 'FAST');
    pdf.save(`SQS-Certificate-${editing?.serial_number || 'preview'}.pdf`);
    toast.success('Certificate downloaded!');
  } catch (err) {
    console.error('PDF error:', err);
    toast.error('Failed to generate PDF');
  }
  setGenerating(false);
};
  const handleDelete = async (id) => {
    if (!window.confirm('Delete?')) return;
    try { await api.delete(`/certificates/${id}`); toast.success('Deleted'); load(); if(editing?.id===id){ setShowPreview(false); setEditing(null); } }
    catch { toast.error('Failed'); }
  };

  return (
    <AdminLayout title="Certificates">
      <div style={{ maxWidth:1100 }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem' }}>
          <p style={{ color:'var(--gray-400)', fontSize:'0.875rem' }}>{certs.length} certificate{certs.length!==1?'s':''} issued</p>
          <button onClick={()=>{ setShowPreview(false); openForm(); }} className="btn btn-navy btn-sm"><FiPlus /> Generate Certificate</button>
        </div>

        {/* Form */}
        {showForm && (
          <motion.div initial={{ opacity:0,y:-16 }} animate={{ opacity:1,y:0 }} style={{ background:'white', borderRadius:'16px', padding:'2rem', marginBottom:'2rem', boxShadow:'var(--shadow)', border:'1px solid #E5E7EB' }}>
            <h3 style={{ fontFamily:'Fraunces,serif', color:'var(--navy)', marginBottom:'1.5rem', fontSize:'1.05rem' }}>{editing?'Edit Certificate':'Generate New Certificate'}</h3>
            <form onSubmit={handleSubmit}>
              <div className="grid-2">
                <div className="form-group"><label className="form-label">Recipient Name *</label><input className="form-input" required value={form.clientName} onChange={e=>setForm({...form,clientName:e.target.value})} placeholder="e.g. Issaka Mustapha" /></div>
                <div className="form-group"><label className="form-label">Company Name</label><input className="form-input" value={form.companyName} onChange={e=>setForm({...form,companyName:e.target.value})} /></div>
              </div>
              <div className="form-group"><label className="form-label">Certificate Title *</label><input className="form-input" required value={form.certificateTitle} onChange={e=>setForm({...form,certificateTitle:e.target.value})} /></div>
              <div className="form-group">
                <label className="form-label">Course / Achievement Description *</label>
                <textarea className="form-input" required style={{ minHeight:90 }} value={form.courseDescription} onChange={e=>setForm({...form,courseDescription:e.target.value})} placeholder="Have successfully completed a training course in Allergen Management on the 15th of May, 2026." />
                <p style={{ fontSize:'0.73rem', color:'var(--gray-400)', marginTop:'0.3rem' }}>This text appears below the recipient's name on the certificate.</p>
              </div>
              <div className="grid-2">
                <div className="form-group"><label className="form-label">Issue Date *</label><input className="form-input" type="date" required value={form.issueDate} onChange={e=>setForm({...form,issueDate:e.target.value})} /></div>
                <div className="form-group"><label className="form-label">Expiry Date (optional)</label><input className="form-input" type="date" value={form.expiryDate} onChange={e=>setForm({...form,expiryDate:e.target.value})} /></div>
              </div>
              <div style={{ background:'var(--off-white)', borderRadius:'10px', padding:'1rem 1.25rem', marginBottom:'1.25rem', border:'1px solid var(--gray-100)' }}>
                <p style={{ fontSize:'0.78rem', fontWeight:600, color:'var(--navy)', marginBottom:'0.75rem', textTransform:'uppercase', letterSpacing:'0.08em' }}>Signatory</p>
                <div className="grid-2">
                  <div className="form-group" style={{ marginBottom:0 }}><label className="form-label">Issued By</label><input className="form-input" value={form.issuedBy} onChange={e=>setForm({...form,issuedBy:e.target.value})} /></div>
                  <div className="form-group" style={{ marginBottom:0 }}><label className="form-label">Title</label><input className="form-input" value={form.issuedByTitle} onChange={e=>setForm({...form,issuedByTitle:e.target.value})} /></div>
                </div>
              </div>
              <div style={{ display:'flex', gap:'0.75rem' }}>
                <button type="submit" className="btn btn-navy btn-sm" disabled={submitting}>{submitting?'Saving...':editing?'Update & Preview':'Create & Preview'}</button>
                <button type="button" className="btn btn-sm" style={{ background:'#F3F4F6', color:'var(--gray-600)' }} onClick={()=>{ setShowForm(false); setEditing(null); }}>Cancel</button>
              </div>
            </form>
          </motion.div>
        )}

        {/* Preview */}
        {showPreview && editing && (
          <motion.div initial={{ opacity:0,y:16 }} animate={{ opacity:1,y:0 }} style={{ background:'white', borderRadius:'16px', padding:'2rem', marginBottom:'2rem', boxShadow:'var(--shadow-lg)', border:'2px solid var(--gold)' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1.5rem', flexWrap:'wrap', gap:'0.75rem' }}>
              <div>
                <h3 style={{ fontFamily:'Fraunces,serif', fontSize:'1rem', color:'var(--navy)' }}>Certificate Preview</h3>
                <p style={{ color:'var(--gray-400)', fontSize:'0.78rem', marginTop:'0.15rem' }}>Serial: <strong style={{ fontFamily:'monospace' }}>{editing.serial_number}</strong></p>
              </div>
              <div style={{ display:'flex', gap:'0.75rem', flexWrap:'wrap' }}>
                <button onClick={()=>openForm(editing)} className="btn btn-sm" style={{ background:'#DBEAFE', color:'#1E40AF', display:'flex', alignItems:'center', gap:'0.4rem' }}><FiEdit2/>Edit</button>
                <button onClick={downloadPDF} className="btn btn-gold btn-sm" disabled={generating} style={{ display:'flex', alignItems:'center', gap:'0.4rem' }}><FiDownload/>{generating?'Generating...':'Download PDF'}</button>
                <button onClick={()=>setShowPreview(false)} className="btn btn-sm" style={{ background:'#F3F4F6', color:'var(--gray-600)' }}>Close</button>
              </div>
            </div>
            <div style={{ overflowX:'auto', background:'#F3F4F6', padding:'1rem', borderRadius:'12px' }}>
              <CertPreview cert={{ ...form, ...editing }} serial={editing.serial_number} qrUrl={qrData?.url||`${window.location.origin}/verify/${editing.serial_number}`} />
            </div>
          </motion.div>
        )}

        {/* Table */}
        <div style={{ background:'white', borderRadius:'16px', overflow:'hidden', boxShadow:'0 1px 4px rgba(0,0,0,0.06)', border:'1px solid #F3F4F6' }}>
          {certs.length===0 ? (
            <div style={{ padding:'4rem', textAlign:'center', color:'var(--gray-400)' }}><div style={{ fontSize:'3rem', marginBottom:'1rem' }}>🏅</div><p>No certificates issued yet.</p></div>
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr style={{ background:'#F9FAFB', borderBottom:'1px solid #F3F4F6' }}>
                {['Serial','Recipient','Certificate','Issue Date','Expiry','Status','Actions'].map(h=><th key={h} style={{ padding:'0.875rem 1rem', textAlign:'left', fontSize:'0.73rem', fontWeight:600, color:'var(--gray-400)', textTransform:'uppercase', letterSpacing:'0.08em' }}>{h}</th>)}
              </tr></thead>
              <tbody>
                {certs.map((c,i)=>(
                  <tr key={c.id} style={{ borderBottom:'1px solid #F9FAFB', background:i%2===0?'white':'#FAFAFA' }}>
                    <td style={{ padding:'0.875rem 1rem', fontFamily:'monospace', fontSize:'0.82rem', color:'var(--navy)', fontWeight:600 }}>{c.serial_number}</td>
                    <td style={{ padding:'0.875rem 1rem' }}>
                      <div style={{ fontWeight:600, color:'var(--navy)', fontSize:'0.875rem' }}>{c.client_name}</div>
                      {c.company_name&&<div style={{ color:'var(--gray-400)', fontSize:'0.77rem' }}>{c.company_name}</div>}
                    </td>
                    <td style={{ padding:'0.875rem 1rem', color:'var(--gray-600)', fontSize:'0.85rem' }}>{c.certificate_title}</td>
                    <td style={{ padding:'0.875rem 1rem', color:'var(--gray-500)', fontSize:'0.8rem' }}>{new Date(c.issue_date).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'})}</td>
                    <td style={{ padding:'0.875rem 1rem', color:'var(--gray-500)', fontSize:'0.8rem' }}>{c.expiry_date?new Date(c.expiry_date).toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric'}):'—'}</td>
                    <td style={{ padding:'0.875rem 1rem' }}><span className={`badge badge-${c.status}`}>{c.status}</span></td>
                    <td style={{ padding:'0.875rem 1rem' }}>
                      <div style={{ display:'flex', gap:'0.4rem' }}>
                        <button onClick={()=>loadPreview(c)} style={{ padding:'0.4rem 0.55rem', borderRadius:'7px', background:'#DCFCE7', color:'#166534', border:'none', cursor:'pointer', fontSize:'0.85rem' }}><FiEye/></button>
                        <button onClick={()=>openForm(c)} style={{ padding:'0.4rem 0.55rem', borderRadius:'7px', background:'#DBEAFE', color:'#1E40AF', border:'none', cursor:'pointer', fontSize:'0.85rem' }}><FiEdit2/></button>
                        <button onClick={()=>handleDelete(c.id)} style={{ padding:'0.4rem 0.55rem', borderRadius:'7px', background:'#FEE2E2', color:'#991B1B', border:'none', cursor:'pointer', fontSize:'0.85rem' }}><FiTrash2/></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </AdminLayout>
  );
}
